import { useAuth } from 'src/utils';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/" />;
  return children;
}
